import task1Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-1-A (1).mp3';
import task2Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-2-A (1).mp3';
import task3Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-3-A (1).mp3';
import task4Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-4-A (1).mp3';
import task5Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-5-A (1).mp3';
import task6Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-6-A (1).mp3';
import task7Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-7-A (1).mp3';
import task8Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-8-A (1).mp3';
import task9Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-9-A (1).mp3';
import task10Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-10-A (1).mp3';
import task11Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-11-A (1).mp3';
import task12Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-12-A (1).mp3';
import task13Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-13-A (1).mp3';
import task14Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-14-A (1).mp3';
import task15Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-15-A (1).mp3';
import task16Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-16-A (1).mp3';
import task17Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-17-A (1).mp3';
import task18Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-21-A (1).mp3';
import task19Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-18-A (1).mp3';
import task20Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-19-A (1).mp3';
import task21Sound from '../../../assets/sounds/adult/sprakforslesaSounds/nn/SF-20-A (1).mp3';

import task1A from '../assets/TestImages/01_1.png';
import task1B from '../assets/TestImages/01_2.png';
import task1C from '../assets/TestImages/01_3.png';
import task1D from '../assets/TestImages/01_4.png';

import task2A from '../assets/TestImages/02_2.png';
import task2B from '../assets/TestImages/02_1.png';
import task2C from '../assets/TestImages/02_3.png';
import task2D from '../assets/TestImages/02_4.png';

import task3A from '../assets/TestImages/03_3.png';
import task3B from '../assets/TestImages/03_2.png';
import task3C from '../assets/TestImages/03_1.png';
import task3D from '../assets/TestImages/03_4.png';

import task4A from '../assets/TestImages/04_2.png';
import task4B from '../assets/TestImages/04_1.png';
import task4C from '../assets/TestImages/04_3.png';
import task4D from '../assets/TestImages/04_4.png';

import task5A from '../assets/TestImages/05_2.png';
import task5B from '../assets/TestImages/05_3.png';
import task5C from '../assets/TestImages/05_4.png';
import task5D from '../assets/TestImages/05_1.png';

import task6A from '../assets/TestImages/06_1.png';
import task6B from '../assets/TestImages/06_2.png';
import task6C from '../assets/TestImages/06_3.png';
import task6D from '../assets/TestImages/06_4.png';

import task7A from '../assets/TestImages/07_3.png';
import task7B from '../assets/TestImages/07_4.png';
import task7C from '../assets/TestImages/07_1.png';
import task7D from '../assets/TestImages/07_2.png';

import task8A from '../assets/TestImages/08_1.png';
import task8B from '../assets/TestImages/08_2.png';
import task8C from '../assets/TestImages/08_3.png';
import task8D from '../assets/TestImages/08_4.png';

import task9A from '../assets/TestImages/09_3.png';
import task9B from '../assets/TestImages/09_4.png';
import task9C from '../assets/TestImages/09_2.png';
import task9D from '../assets/TestImages/09_1.png';

import task10A from '../assets/TestImages/10_2.png';
import task10B from '../assets/TestImages/10_1.png';
import task10C from '../assets/TestImages/10_3.png';
import task10D from '../assets/TestImages/10_4.png';

import task11A from '../assets/TestImages/11_3.png';
import task11B from '../assets/TestImages/11_1.png';
import task11C from '../assets/TestImages/11_4.png';
import task11D from '../assets/TestImages/11_2.png';

import task12A from '../assets/TestImages/12_3.png';
import task12B from '../assets/TestImages/12_4.png';
import task12C from '../assets/TestImages/12_1.png';
import task12D from '../assets/TestImages/12_2.png';

import task13A from '../assets/TestImages/13_1.png';
import task13B from '../assets/TestImages/13_2.png';
import task13C from '../assets/TestImages/13_3.png';
import task13D from '../assets/TestImages/13_4.png';

import task14A from '../assets/TestImages/14_3.png';
import task14B from '../assets/TestImages/14_2.png';
import task14C from '../assets/TestImages/14_4.png';
import task14D from '../assets/TestImages/14_1.png';

import task15A from '../assets/TestImages/15_2.png';
import task15B from '../assets/TestImages/15_1.png';
import task15C from '../assets/TestImages/15_3.png';
import task15D from '../assets/TestImages/15_4.png';

import task16A from '../assets/TestImages/19_2.png';
import task16B from '../assets/TestImages/19_1.png';
import task16C from '../assets/TestImages/19_3.png';
import task16D from '../assets/TestImages/19_4.png';

import task17A from '../assets/TestImages/20_2.png';
import task17B from '../assets/TestImages/20_3.png';
import task17C from '../assets/TestImages/20_1.png';
import task17D from '../assets/TestImages/20_4.png';

import task18A from '../assets/TestImages/21_1.png';
import task18B from '../assets/TestImages/21_2.png';
import task18C from '../assets/TestImages/21_3.png';
import task18D from '../assets/TestImages/21_4.png';

import task19A from '../assets/TestImages/16_a_2.png';
import task19B from '../assets/TestImages/16_b1.png';
import task19C from '../assets/TestImages/16_a_1.png';
import task19D from '../assets/TestImages/16_b_2.png';
import task19E from '../assets/TestImages/16_c_2.png';
import task19F from '../assets/TestImages/16_c_1.png';

import task20A from '../assets/TestImages/17_2.png';
import task20B from '../assets/TestImages/17_5.png';
import task20C from '../assets/TestImages/17_3.png';
import task20D from '../assets/TestImages/17_8.png';
import task20E from '../assets/TestImages/17_1.png';
import task20F from '../assets/TestImages/17_7.png';

import task21A from '../assets/TestImages/18_3.png';
import task21B from '../assets/TestImages/18_2.png';
import task21C from '../assets/TestImages/18_8.png';
import task21D from '../assets/TestImages/18_7.png';
import task21E from '../assets/TestImages/18_9.png';
import task21F from '../assets/TestImages/18_1.png';
import task21G from '../assets/TestImages/18_10.png';
import task21H from '../assets/TestImages/18_4.png';
import task21I from '../assets/TestImages/18_5.png';

export const assignment1 = [
	{
		id: 1,
		mainSound: task1Sound,
		text: 'Pek på dama som hverken har et eple eller en veske, men en bok.',
		choices: [
			{
				word: 'a',
				remarks: 'true',
				img: task1A,
			},
			{
				word: 'b',
				remarks: 'false',
				img: task1B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task1C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task1D,
			},
		],
	},
];
export const assignment2 = [
	{
		id: 2,
		mainSound: task2Sound,
		text: 'Trykk på eleven som har hverken ryggsekk eller bok, men som har lue og briller.',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task2A,
			},
			{
				word: 'b',
				remarks: 'true',
				img: task2B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task2C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task2D,
			},
		],
	},
];
export const assignment3 = [
	{
		id: 3,
		mainSound: task3Sound,
		text: 'Trykk på mannen som hverken har på seg caps eller solbriller, men som bærer på en koffert og en paraply.',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task3A,
			},
			{
				word: 'b',
				remarks: 'false',
				img: task3B,
			},
			{
				word: 'c',
				remarks: 'true',
				img: task3C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task3D,
			},
		],
	},
];
export const assignment4 = [
	{
		id: 4,
		mainSound: task4Sound,
		text: 'Gutten har vunnet medalje, men er likevel lei seg fordi han ikke også fikk krone.',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task4A,
			},
			{
				word: 'b',
				remarks: 'true',
				img: task4B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task4C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task4D,
			},
		],
	},
];
export const assignment5 = [
	{
		id: 5,
		mainSound: task5Sound,
		text: 'De gule stjernene er mindre enn den grønne månen, men større enn den blå stjerna',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task5A,
			},
			{
				word: 'b',
				remarks: 'false',
				img: task5B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task5C,
			},
			{
				word: 'd',
				remarks: 'true',
				img: task5D,
			},
		],
	},
];
export const assignment6 = [
	{
		id: 6,
		mainSound: task6Sound,
		text: 'Glasset med melk er fullere enn glasset med vann, men ikke fullere enn glasset med saft.',
		choices: [
			{
				word: 'a',
				remarks: 'true',
				img: task6A,
			},
			{
				word: 'b',
				remarks: 'false',
				img: task6B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task6C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task6D,
			},
		],
	},
];
export const assignment7 = [
	{
		id: 7,
		mainSound: task7Sound,
		text: 'Det røde huset er høyere enn flaggstanga, men lavere enn det brune huset ved siden av.',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task7A,
			},
			{
				word: 'b',
				remarks: 'false',
				img: task7B,
			},
			{
				word: 'c',
				remarks: 'true',
				img: task7C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task7D,
			},
		],
	},
];
export const assignment8 = [
	{
		id: 8,
		mainSound: task8Sound,
		text: 'Den grønne boken ligger over den blå, men under den røde boken.',
		choices: [
			{
				word: 'a',
				remarks: 'true',
				img: task8A,
			},
			{
				word: 'b',
				remarks: 'false',
				img: task8B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task8C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task8D,
			},
		],
	},
];
export const assignment9 = [
	{
		id: 9,
		mainSound: task9Sound,
		text: 'Kvinnen med langt hår står og leser, mens kvinnen med kort hår sitter og skriver.',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task9A,
			},
			{
				word: 'b',
				remarks: 'false',
				img: task9B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task9C,
			},
			{
				word: 'd',
				remarks: 'true',
				img: task9D,
			},
		],
	},
];
export const assignment10 = [
	{
		id: 10,
		mainSound: task10Sound,
		text: 'Den svarte katten sover under benken mens den hvite hunden leker med en ball.',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task10A,
			},
			{
				word: 'b',
				remarks: 'true',
				img: task10B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task10C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task10D,
			},
		],
	},
];
export const assignment11 = [
	{
		id: 11,
		mainSound: task11Sound,
		text: 'Når brødrene er ferdig med å fiske, kan pappa steke fisken på bålet.',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task11A,
			},
			{
				word: 'b',
				remarks: 'true',
				img: task11B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task11C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task11D,
			},
		],
	},
];
export const assignment12 = [
	{
		id: 12,
		mainSound: task12Sound,
		text: 'Når barna har malt gjerdet, kan pappa plante blomster i hagen.',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task12A,
			},
			{
				word: 'b',
				remarks: 'false',
				img: task12B,
			},
			{
				word: 'c',
				remarks: 'true',
				img: task12C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task12D,
			},
		],
	},
];
export const assignment13 = [
	{
		id: 13,
		mainSound: task13Sound,
		text: 'Garasjen var lys blå, men er nå malt til å være likt som huset.',
		choices: [
			{
				word: 'a',
				remarks: 'true',
				img: task13A,
			},
			{
				word: 'b',
				remarks: 'false',
				img: task13B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task13C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task13D,
			},
		],
	},
];
export const assignment14 = [
	{
		id: 14,
		mainSound: task14Sound,
		text: 'Gjerdet var grønt, men er nå malt til å være likt som døra. Veggene på huset er fortsatt blå.',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task14A,
			},
			{
				word: 'b',
				remarks: 'false',
				img: task14B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task14C,
			},
			{
				word: 'd',
				remarks: 'true',
				img: task14D,
			},
		],
	},
];
export const assignment15 = [
	{
		id: 15,
		mainSound: task15Sound,
		text: 'Sykkelen sto ved siden av garasjen, men er nå flyttet inn, mens sparkesykkelen som lå i hagen nå er flyttet til oppkjørselen.',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task15A,
			},
			{
				word: 'b',
				remarks: 'true',
				img: task15B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task15C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task15D,
			},
		],
	},
];

export const assignment16 = [
	{
		id: 16,
		mainSound: task16Sound,
		text: 'Sykkelen sto ved siden av garasjen, men er nå flyttet inn, mens sparkesykkelen som lå i hagen nå er flyttet til oppkjørselen.',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task16A,
			},
			{
				word: 'b',
				remarks: 'true',
				img: task16B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task16C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task16D,
			},
		],
	},
];

export const assignment17 = [
	{
		id: 17,
		mainSound: task17Sound,
		text: 'Sykkelen sto ved siden av garasjen, men er nå flyttet inn, mens sparkesykkelen som lå i hagen nå er flyttet til oppkjørselen.',
		choices: [
			{
				word: 'a',
				remarks: 'false',
				img: task17A,
			},
			{
				word: 'b',
				remarks: 'false',
				img: task17B,
			},
			{
				word: 'c',
				remarks: 'true',
				img: task17C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task17D,
			},
		],
	},
];

export const assignment18 = [
	{
		id: 18,
		mainSound: task18Sound,
		text: '',
		choices: [
			{
				word: 'a',
				remarks: 'true',
				img: task18A,
			},
			{
				word: 'b',
				remarks: 'false',
				img: task18B,
			},
			{
				word: 'c',
				remarks: 'false',
				img: task18C,
			},
			{
				word: 'd',
				remarks: 'false',
				img: task18D,
			},
		],
	},
];

export const assignment19 = [
	{
		id: 19,
		mainSound: task19Sound,
		text: 'Trykk på figurene i denne rekkefølgen: én stor sirkel, to små firkanter, og én liten trekant.',
		choices: [
			{
				word: 'a',
				img: task19A,
			},
			{
				word: 'b',
				img: task19B,
			},
			{
				word: 'c',
				img: task19C,
			},
			{
				word: 'd',
				img: task19D,
			},
			{
				word: 'e',
				img: task19E,
			},
			{
				word: 'f',
				img: task19F,
			},
		],
		correctOrder: ['c', 'b', 'f'],
	},
];
export const assignment20 = [
	{
		id: 20,
		mainSound: task20Sound,
		text: 'Trykk på fruktene i denne rekkefølgen: tre epler, én stor banan, to små pærer, og en ananas.',
		choices: [
			{
				word: 'a',
				img: task20A,
			},
			{
				word: 'b',
				img: task20B,
			},
			{
				word: 'c',
				img: task20C,
			},
			{
				word: 'd',
				img: task20D,
			},
			{
				word: 'e',
				img: task20E,
			},
			{
				word: 'f',
				img: task20F,
			},
		],
		correctOrder: ['e', 'a', 'c', 'f'],
	},
];
export const assignment21 = [
	{
		id: 21,
		mainSound: task21Sound,
		text: 'Trykk på dyrene i rekkefølgen: to løver, fire krokodiller, tre elefanter, og én giraff.',
		choices: [
			{
				word: 'a',
				img: task21A,
			},
			{
				word: 'b',
				img: task21B,
			},
			{
				word: 'c',
				img: task21C,
			},
			{
				word: 'd',
				img: task21D,
			},
			{
				word: 'e',
				img: task21E,
			},
			{
				word: 'f',
				img: task21F,
			},
			{
				word: 'g',
				img: task21G,
			},
			{
				word: 'h',
				img: task21H,
			},
			{
				word: 'i',
				img: task21I,
			},
		],
		correctOrder: ['f', 'g', 'a', 'i'],
	},
];
